module.exports = __webpack_public_path__ + "img/swiper_3.5_2_2.3a9530a0.webp";